import { useState, useEffect, Fragment } from "react";
import Paper from "@mui/material/Paper";
import CircularProgress from "@mui/material/CircularProgress";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableHead from "@mui/material/TableHead";

import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import Moment from "react-moment";
import FleetWebApi from "../Api/FleetWebApi";
import { useAuthDataContext } from "../AuthDataProvider";

function MfgWebNotes(props) {
  const [note, setNote] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState();
  const { user } = useAuthDataContext();
  useEffect(() => {
    let isMounted = true;
    setIsLoading(true);
    FleetWebApi.getMfgWebNotesBySerial(props.serial, user.token)
      .then((response) => {
        if (isMounted) {
          setNote(response);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        if (isMounted) {
          console.log(error);
          setError(error.message);
          setIsLoading(false);
        }
      });
    return () => {
      isMounted = false;
      setNote([]);
    };
  }, [props.serial]);
  return (
    <Fragment>
      <h3>MfgWeb Notes</h3>
      <Paper>
        {isLoading ? (
          <CircularProgress color="secondary" />
        ) : !isLoading && error ? (
          error
        ) : !isLoading && !error && note.length > 0 ? (
          <Table classes={{ root: "reactivetable" }}>
            <TableHead>
              <TableRow>
                <TableCell>Timestamp</TableCell>
                <TableCell>Note</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {note.map((data, key) => (
                <TableRow key={key}>
                  <TableCell data-th="Note Timestamp">
                    {data.date ? (
                      <Moment format="YYYY-MM-DD HH:mm:ss Z">
                        {data.date}
                      </Moment>
                    ) : (
                      <div>-</div>
                    )}
                  </TableCell>
                  <TableCell data-th="Note Detail">{data.details}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        ) : (
          <Table>
            <TableBody>
              <TableRow>
                <TableCell>No Notes found</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        )}
      </Paper>
    </Fragment>
  );
}

export default MfgWebNotes;
